// Read a File, resize on the longest edge, and return a compressed data URL.
export function fileToCompressedDataURL(
    file,
    maxEdge = 900,
    quality = 0.82,
    preserveTransparency = false,
) {
    return new Promise((resolve, reject) => {
        if (!file) return reject(new Error("no file"));
        if (!file.type.startsWith("image/")) return reject(new Error("非图片文件"));

        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;
                if (width > maxEdge || height > maxEdge) {
                    if (width >= height) {
                        height = Math.round((height * maxEdge) / width);
                        width = maxEdge;
                    } else {
                        width = Math.round((width * maxEdge) / height);
                        height = maxEdge;
                    }
                }
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                if (!preserveTransparency) {
                    ctx.fillStyle = "#ffffff";
                    ctx.fillRect(0, 0, width, height);
                }
                ctx.drawImage(img, 0, 0, width, height);
                const outputType = preserveTransparency ? "image/png" : "image/jpeg";
                resolve(canvas.toDataURL(outputType, quality));
            };
            img.onerror = () => reject(new Error("图片读取失败"));
            img.src = reader.result;
        };
        reader.onerror = () => reject(new Error("文件读取失败"));
        reader.readAsDataURL(file);
    });
}

// Read a File, resize on the longest edge, and return a compressed JPEG Blob.
export function fileToCompressedBlob(file, maxEdge = 2400, quality = 0.85) {
    return new Promise((resolve, reject) => {
        if (!file) return reject(new Error("no file"));
        if (!file.type.startsWith("image/")) return reject(new Error("非图片文件"));

        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;
                if (width > maxEdge || height > maxEdge) {
                    if (width >= height) {
                        height = Math.round((height * maxEdge) / width);
                        width = maxEdge;
                    } else {
                        width = Math.round((width * maxEdge) / height);
                        height = maxEdge;
                    }
                }
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.fillStyle = "#ffffff";
                ctx.fillRect(0, 0, width, height);
                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob(
                    (blob) => (blob ? resolve(blob) : reject(new Error("图片压缩失败"))),
                    "image/jpeg",
                    quality,
                );
            };
            img.onerror = () => reject(new Error("图片读取失败"));
            img.src = reader.result;
        };
        reader.onerror = () => reject(new Error("文件读取失败"));
        reader.readAsDataURL(file);
    });
}
